module.exports = __webpack_public_path__ + "static/img/comsoft-erp1.2fd4160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comsoft-erp1.png
// module id = CjZv
// module chunks = 1